import React from "react";

const Error = () => {
  return (
    <div style={{ backgroundImage: "url(images/auth-bg/bg-5.jpg)" }}>
      <section className="error-page h-p100">
        <div className="container h-p100">
          <div className="row h-p100 align-items-center justify-content-center text-center">
            <div className="col-lg-7 col-md-10 col-12">
              <div className="rounded30 p-50">
                <img
                  src="images/auth-bg/500.jpg"
                  className="max-w-200"
                  alt=""
                />
                <h1>Uh-Ah</h1>
                <h3>Internal Server Error !</h3>
                <div className="my-30">
                  <a href="index.html" className="btn btn-info">
                    Back to dashboard
                  </a>
                </div>
                <h5 className="mb-15">-- OR --</h5>
                <h4>Please try after some time</h4>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Error;
